import { DailySchedule, IProgramSetup, IProgramSetupForm } from 'shared/interfaces/IProgramSetup';

const DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

const withDate = (time?: string | null) => (time && !time.includes('1990-01-01') ? `1990-01-01 ${time}` : time);

/**
 * Maps a saved program setup record back into the shape the create/update API expects,
 * without touching the record itself (it usually lives in the react-query cache).
 * Used where a record is re-saved outside its own form, e.g. Channel Settings on the list.
 */
export const programSetupRecordToForm = (record: IProgramSetup, mode: 'tv' | 'radio'): IProgramSetupForm => {
  const dailySchedule = {} as DailySchedule;
  DAYS.forEach((day) => {
    const slot = record.daily_schedule?.[day] || {};
    dailySchedule[day] = {
      ...slot,
      timeslot_start: withDate(slot.timeslot_start),
      timeslot_end: withDate(slot.timeslot_end),
      automation_enabled: slot.automation_enabled ?? false,
    };
  });

  const chapterSchedule = {} as NonNullable<IProgramSetupForm['chapter_schedule']>;
  DAYS.forEach((day) => {
    chapterSchedule[day] = {
      chapter_start: record.chapter_schedule?.[day]?.chapter_start ?? '',
      chapter_end: record.chapter_schedule?.[day]?.chapter_end ?? '',
    };
  });

  return {
    anchors: record.anchors?.map((anchor) => anchor?._id) || [],
    channel_obj: mode === 'tv' ? record.channel_details?._id : null,
    program_obj: mode === 'tv' ? record.program_details?._id : null,
    station_obj: record.station_details?._id || null,
    station_program_obj: record.station_program_details?._id || null,
    youtube_scrape_details: record.youtube_scrape_details,
    facebook_scraper_details: record.facebook_scraper_details,
    local_recording_details: { ...record.local_recording_details },
    youtube_title_setup: record.youtube_title_setup,
    facebook_title_setup: record.facebook_title_setup,
    recording_title_setup: record.recording_title_setup ? { ...record.recording_title_setup } : null,
    country: record.country,
    segment_type: record.segment_type,
    daily_schedule: dailySchedule,
    chapter_schedule: chapterSchedule,
  };
};
